var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#14142A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3273 12L14.6841 11.6497C14.875 11.8442 14.875 12.1558 14.6841 12.3503L14.3273 12ZM10.0432 8.3503C9.84975 8.15325 9.85266 7.83668 10.0497 7.64322C10.2467 7.44976 10.5633 7.45266 10.7568 7.6497L10.0432 8.3503ZM10.7568 16.3503C10.5633 16.5473 10.2467 16.5502 10.0497 16.3568C9.85266 16.1633 9.84975 15.8468 10.0432 15.6497L10.7568 16.3503ZM13.9705 12.3503L10.0432 8.3503L10.7568 7.6497L14.6841 11.6497L13.9705 12.3503ZM14.6841 12.3503L10.7568 16.3503L10.0432 15.6497L13.9705 11.6497L14.6841 12.3503Z",
    fill: "#4ED5D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledArrow);
export default __webpack_public_path__ + "static/media/filledArrow.a41baa761ab44ae8b27b523549c4cdb8.svg";
export { ForwardRef as ReactComponent };